module.exports = __webpack_public_path__ + "static/img/brand-11.ddd57c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-11.svg
// module id = evaP
// module chunks = 0